import React from 'react';
import IconButton from '../base/IconButton';

interface AddressCardProps {
  type: 'pickup' | 'dropoff';
  address: string;
  contactName?: string;
  contactPhone?: string;
  note?: string;
  onCall?: () => void;
  onNavigate?: () => void;
  onCopy?: () => void;
}

export default function AddressCard({
  type,
  address,
  contactName,
  contactPhone,
  note,
  onCall,
  onNavigate,
  onCopy,
}: AddressCardProps) {
  const isPickup = type === 'pickup';
  
  return (
    <div className="bg-white rounded-2xl p-4 shadow-md border border-gray-100">
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
          isPickup ? 'bg-blue-100' : 'bg-green-100'
        }`}>
          <i className={`${isPickup ? 'ri-store-3-line' : 'ri-map-pin-user-line'} text-lg ${
            isPickup ? 'text-blue-600' : 'text-green-600'
          }`}></i>
        </div>
        
        <div className="flex-1">
          <p className="text-xs font-semibold text-gray-500 uppercase mb-1">
            {isPickup ? 'Upphämtning' : 'Leverans'}
          </p>
          <p className="text-sm font-semibold text-gray-900 mb-2">{address}</p>
          
          {contactName && (
            <div className="flex items-center gap-2 mb-1">
              <i className="ri-user-line text-sm text-gray-500"></i>
              <span className="text-sm text-gray-700">{contactName}</span>
            </div>
          )}
          
          {contactPhone && (
            <div className="flex items-center gap-2 mb-2">
              <i className="ri-phone-line text-sm text-gray-500"></i>
              <span className="text-sm text-gray-700">{contactPhone}</span>
            </div>
          )}
          
          {note && (
            <div className="mt-2 p-2 bg-amber-50 rounded-lg border border-amber-200">
              <div className="flex items-start gap-2">
                <i className="ri-information-line text-sm text-amber-600 mt-0.5"></i>
                <p className="text-xs text-amber-800">{note}</p>
              </div>
            </div>
          )}
        </div>
      </div>
      
      <div className="flex items-center gap-2 mt-3 pt-3 border-t border-gray-100">
        {onCall && (
          <IconButton
            icon="ri-phone-line"
            onClick={onCall}
            variant="secondary"
            size="small"
            ariaLabel="Ring"
          />
        )}
        {onNavigate && (
          <IconButton
            icon="ri-navigation-line"
            onClick={onNavigate}
            variant="primary"
            size="small"
            ariaLabel="Navigera"
          />
        )}
        {onCopy && (
          <IconButton
            icon="ri-file-copy-line"
            onClick={onCopy}
            variant="ghost"
            size="small"
            ariaLabel="Kopiera adress"
          />
        )}
      </div>
    </div>
  );
}
